<template>
    <div style="height: 100%;">
        <el-container style="height: 100%;">
          <el-main class="section chat-report-main">
            <el-tabs stretch type="card" v-model="tabActiveName">
              <el-tab-pane label="排队趋势分析" name="queueTrend">
                <QueueTrend ref="queueTrend" v-if="tabActiveName === 'queueTrend'"/>
              </el-tab-pane>
              <el-tab-pane label="排队明细" name="queueDetail">
                <QueueDetail ref="satisfiedTrend" v-if="tabActiveName === 'queueDetail'"/>
              </el-tab-pane>
            </el-tabs>
          </el-main>
        </el-container>
    </div>
</template>
<script>
import QueueTrend from '@/views/workreport/queue/analyze/QueueTrend'
import QueueDetail from '@/views/workreport/queue/analyze/QueueDetail'
export default {
  name: '',
  components: {
    QueueTrend,
    QueueDetail
  },
  data() {
    return {
      tabActiveName: 'queueTrend'
    }
  },
  mounted() {
  },
  methods: {
    getPage(data) {
      this.page = data
    }
  }
}
</script>
<style lang="scss">
.chat-report-main{
  .el-tabs__content{
    height: 100% !important;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{margin-bottom:10px;}
}
.el-main .el-main{padding:0px;}
.el-main .el-main section{padding:0px;}
</style>
